import { render, staticRenderFns } from "./VerifyIntranetMFA.vue?vue&type=template&id=5370d1ae&scoped=true"
import script from "./VerifyIntranetMFA.vue?vue&type=script&lang=js"
export * from "./VerifyIntranetMFA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5370d1ae",
  null
  
)

export default component.exports